<template>
  <v-dialog v-model="dialog" max-width="1200px" persistent>
    <v-card v-if="editedItem" class="overflow-hidden d-flex flex-column" style="max-height: 80vh">
      <v-card-title class="dialog-header-footer">
        <span class="text-h5 pl-2 pb-2">{{ formTitle }}</span>
      </v-card-title>

      <v-card-subtitle class="d-flex flex-column justify-start full-width caption dialog-header-footer mb-4">
        <v-row v-if="editedItem.id" style="gap: 20px" class="px-5 pt-2">
          <div v-if="isDisplayed('id') && editedItem.id">ID: {{ editedItem.id }}</div>
          <div v-if="isDisplayed('createdAt') && editedItem.createdAt">erfasst am: {{ mx_createdAt(editedItem) }}</div>
          <div v-if="isDisplayed('lastModifiedAt') && editedItem.updatedAt">geändert am: {{ mx_updatedAt(editedItem) }}</div>
        </v-row>
      </v-card-subtitle>
      <v-card-text style="overflow-y: scroll">
        <v-row class="pl-5 justify-start">
          <v-form ref="form" v-model="editFormValid">
            <v-row nowrap class="pt-5" ref="firstRow">
              <v-col v-if="isDisplayed('reason')" cols="3" class="py-0">
                <v-select
                  v-model="editedItem.reasonId"
                  :items="reasons"
                  item-text="text"
                  item-value="id"
                  placeholder="Grund erfassen"
                  label="Grund *"
                  :rules="reasonRules"
                  required
                ></v-select>
              </v-col>

              <v-col v-if="isDisplayed('crewReport')" cols="2" class="py-0">
                <v-checkbox v-model="editedItem.crewReport" label="Crew ok"></v-checkbox>
              </v-col>

              <v-col v-if="isDisplayed('supervisorReport')" cols="2" sm="3" class="mb-4 py-0">
                <v-checkbox v-model="editedItem.supervisorReport" style="white-space: nowrap" label="Meldung Vorg."></v-checkbox>
              </v-col>

              <v-col v-if="isDisplayed('department') && editedItem._mode !== 'singleRowEdit'" cols="3" sm="3" class="pb-2 mr-0">
                <div>Abteilung</div>
                <div class="flex-row flex-nowrap">
                  <v-chip small @click="setFzgType(null)" :color="!fzgType ? 'primary' : ''">nicht relevant</v-chip>
                  <v-chip small @click="setFzgType('Bus')" :color="fzgType === 'Bus' ? 'primary' : ''">Bus </v-chip>
                  <v-chip class="ml-1" small @click="setFzgType('Tram')" :color="fzgType === 'Tram' ? 'primary' : ''">Tram </v-chip>
                </div>
              </v-col>
            </v-row>

            <v-row v-if="editedItem._mode !== 'singleRowEdit'">
              <!-- Anonymous illness reasons-->
              <v-col v-if="isDisplayed('anonymousIllnessReason')" cols="5" class="py-0">
                <v-select
                  v-model="editedItem.illnessReasonId"
                  :items="illnessReasonsExtended"
                  item-text="text"
                  item-value="id"
                  placeholder="Krankheitsgrund erfassen"
                  label="Krankheitsgrund"
                  required
                ></v-select>
              </v-col>
              <v-col v-if="isDisplayed('illnessReason') && needsIllnessReasonText" cols="7" class="py-0">
                <v-text-field v-model="editedItem.illnessReason" placeholder="Krankheitsgrund erfassen" clearable label="Krankheitsgrund"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="isDisplayed('vbzNr')" cols="4" class="py-0 d-flex">
                <v-dialog v-model="isPersonLookupDialogOpenVbzNr" width="500" height="600">
                  <person-autocomplete
                    :vbzNrString="editedItem.vbzNr"
                    label="VBZ Nr./MitarbeiterIn (Name nicht gespeichert)"
                    @cancel="isPersonLookupDialogOpenVbzNr = false"
                    @save="
                      (vbzNr) => {
                        isPersonLookupDialogOpenVbzNr = false;
                        editedItem.vbzNr = vbzNr;
                      }
                    "
                  ></person-autocomplete
                ></v-dialog>
                <v-btn class="mt-3 move-minus-10" icon @click="isPersonLookupDialogOpenVbzNr = true"><v-icon size="20">mdi-account-search</v-icon></v-btn>
                <v-text-field class="d-flex" clearable v-model="editedItem.vbzNr" label="VBZ Nr."></v-text-field>
              </v-col>

              <v-col v-if="isDisplayed('zueri9VbzNr')" cols="4" class="d-flex py-0">
                <v-dialog v-model="isPersonLookupDialogOpenZueri9VbzNr" width="500" height="600">
                  <person-autocomplete
                    :vbzNrString="editedItem.zueri9VbzNr"
                    label="VBZ Nr./MitarbeiterIn (Name nicht gespeichert)"
                    @cancel="isPersonLookupDialogOpenZueri9VbzNr = false"
                    @save="
                      (vbzNr) => {
                        isPersonLookupDialogOpenZueri9VbzNr = false;
                        editedItem.zueri9VbzNr = vbzNr;
                      }
                    "
                  ></person-autocomplete
                ></v-dialog>
                <v-btn class="mt-3 move-minus-10" icon @click="isPersonLookupDialogOpenZueri9VbzNr = true"><v-icon size="20">mdi-account-search</v-icon></v-btn>
                <v-text-field class="d-flex" clearable v-model="editedItem.zueri9VbzNr" label="VBZ Nr."></v-text-field>
              </v-col>

              <v-col v-if="isDisplayed('zueri9VbzNr')" cols="4" class="d-flex py-0 align-center">
                <div class="d-flex">{{ mx_zueri9VbzNrSortValue(editedItem) }}</div>
              </v-col>
            </v-row>

            <v-row>
              <!-- orig disble rule:  :disabled="!((mx_isDispoView && editedItem.vbzNr) || (mx_isZueri9View && editedItem.zueri9VbzNr))" -->
              <v-col v-if="isDisplayed('duty') || isDisplayed('z9Duty')" cols="4" class="py-0 d-flex">
                <v-btn class="mt-3 move-minus-10" :disabled="!(mx_isDispoView || mx_isZueri9View)" icon @click="isDutyLookupDialogOpen = true"
                  ><v-icon size="20">mdi-text-search</v-icon></v-btn
                >
                <v-dialog v-if="isDutyLookupDialogOpen" v-model="isDutyLookupDialogOpen" max-width="1400px">
                  <duty-lookup
                    v-if="mx_isDispoView"
                    :number-of-used-items="editedItem._mode === 'singleRowEdit' ? 1 : 2"
                    :day="currentDate"
                    :vbzNr="editedItem.vbzNr"
                    vbzNrAttribute="vbzNr"
                    @cancel="isDutyLookupDialogOpen = false"
                    @onDutySelected="onDutySelected"
                  ></duty-lookup>
                  <duty-lookup
                    v-else
                    :number-of-used-items="1"
                    :day="currentDate"
                    :vbzNr="editedItem.zueri9VbzNr"
                    vbzNrAttribute="zueri9VbzNr"
                    @cancel="isDutyLookupDialogOpen = false"
                    @onDutySelected="onDutySelected"
                  ></duty-lookup>
                </v-dialog>
                <v-text-field v-if="mx_isDispoView" clearable v-model="editedItem.duty" label="Dienst"></v-text-field>
                <v-text-field v-else-if="mx_isZueri9View" clearable v-model="editedItem.z9Duty" label="Dienst"></v-text-field>
              </v-col>

              <template v-if="mx_isDispoView">
                <v-col v-if="isDisplayed('dutyFrom')" cols="1" class="py-0">
                  <time-field v-model="editedItem.dutyFrom" :defaultDate="currentDate" label="Beginn"></time-field>
                </v-col>
                <v-col v-if="isDisplayed('dutyFromLoc')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.dutyFromLoc" label="Dienst von"></v-text-field>
                </v-col>
                <v-col v-if="isDisplayed('dutyUntil')" cols="1" class="py-0">
                  <time-field v-model="editedItem.dutyUntil" :defaultDate="currentDate" label="Ende"></time-field>
                </v-col>
                <v-col v-if="isDisplayed('dutyUntilLoc')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.dutyUntilLoc" label="Dienst nach"></v-text-field>
                </v-col>
                <v-col v-if="isDisplayed('line')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.line" label="Linie/Kurs"></v-text-field>
                </v-col>
              </template>
              <template v-if="mx_isZueri9View">
                <v-col v-if="isDisplayed('z9DutyFrom')" cols="1" class="py-0">
                  <time-field v-model="editedItem.z9DutyFrom" :defaultDate="currentDate" label="Beginn"></time-field>
                </v-col>
                <v-col v-if="isDisplayed('z9DutyFromLoc')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.z9DutyFromLoc" label="Dienst von"></v-text-field>
                </v-col>
                <v-col v-if="isDisplayed('z9DutyUntil')" cols="1" class="py-0">
                  <time-field v-model="editedItem.z9DutyUntil" :defaultDate="currentDate" label="Ende"></time-field>
                </v-col>
                <v-col v-if="isDisplayed('z9DutyUntilLoc')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.z9DutyUntilLoc" label="Dienst nach"></v-text-field>
                </v-col>
                <v-col v-if="isDisplayed('z9Line')" cols="2" class="py-0">
                  <v-text-field clearable v-model="editedItem.z9Line" label="Linie/Kurs"></v-text-field>
                </v-col>
              </template>
            </v-row>
            <v-row v-if="editedItem._mode === 'doubleRowCreate'">
              <v-col v-if="isDisplayed('duty2')" cols="4" class="py-0">
                <v-text-field clearable style="margin-left: 40px" v-model="editedItem.duty2" label="Dienst"></v-text-field>
              </v-col>
              <v-col v-if="isDisplayed('dutyFrom2')" cols="1" class="py-0">
                <time-field v-model="editedItem.dutyFrom2" :defaultDate="currentDate" label="Beginn"></time-field>
              </v-col>
              <v-col v-if="isDisplayed('dutyFromLoc2')" cols="2" class="py-0">
                <v-text-field clearable v-model="editedItem.dutyFromLoc2" label="Dienst von"></v-text-field>
              </v-col>
              <v-col v-if="isDisplayed('dutyUntil2')" cols="1" class="py-0">
                <time-field v-model="editedItem.dutyUntil2" :defaultDate="currentDate" label="Ende"></time-field>
              </v-col>
              <v-col v-if="isDisplayed('dutyUntilLoc2')" cols="2" class="py-0">
                <v-text-field clearable v-model="editedItem.dutyUntilLoc2" label="Dienst nach"></v-text-field>
              </v-col>
              <v-col v-if="isDisplayed('line2')" cols="2" class="py-0">
                <v-text-field clearable v-model="editedItem.line2" label="Linie/Kurs"></v-text-field>
              </v-col>
            </v-row>

            <v-row v-if="mx_isZueri9View && editedItem.dutySelection">
              <duty-parts-view
                v-if="dutySelection && dutySelection.resolvedDutyActivities"
                class="ml-12"
                :dutyNameDetails="editedItem.z9Duty"
                :dutySelection="dutySelection"
              ></duty-parts-view>

              <duty-parts-own-data-view
                v-else-if="dutySelection"
                :dutyNameDetails="editedItem.z9Duty"
                :dutySelection="dutySelection"
              ></duty-parts-own-data-view>
              <!--              <div class="scroll-container"><pre><code>{{JSON.stringify(editedItem,null,2)}}</code></pre></div>-->
            </v-row>

            <v-row v-if="mx_isZueri9View">
              <v-col v-if="isDisplayed('zueri9Remarks')" cols="12" class="py-0">
                <v-text-field clearable v-model="editedItem.remarks" label="Bemerkung"></v-text-field>
              </v-col>
              <v-col v-if="isDisplayed('zueri9Client')" cols="3" class="py-0">
                <v-select clearable v-model="editedItem.zueri9ClientId" :items="zueri9Clients" item-text="text" item-value="id" label="Für wen"></v-select>
              </v-col>
              <v-col v-if="isDisplayed('zueri9Reason')" cols="3" class="py-0">
                <v-select
                  v-model="editedItem.zueri9ReasonId"
                  :items="zueri9Reasons"
                  item-text="text"
                  item-value="id"
                  clearable
                  placeholder="Was"
                  label="Für was"
                ></v-select>
              </v-col>
            </v-row>
            <v-row class="pt-7">
              <v-col v-if="isDisplayed('backup1')" cols="5" class="py-0 d-flex">
                <v-dialog v-model="isPersonLookupDialogOpenBackup1" width="500" height="600">
                  <person-autocomplete
                    :vbzNrString="editedItem.backup1"
                    label="Ersatz erfassen"
                    @cancel="isPersonLookupDialogOpenBackup1 = false"
                    @save="
                      (vbzNr) => {
                        isPersonLookupDialogOpenBackup1 = false;
                        editedItem.backup1 = vbzNr;
                      }
                    "
                  ></person-autocomplete
                ></v-dialog>
                <v-btn class="mt-3 move-minus-10" icon @click="isPersonLookupDialogOpenBackup1 = true"><v-icon size="20">mdi-account-search</v-icon></v-btn>
                <v-text-field class="d-flex" clearable v-model="editedItem.backup1" label="Ersatz 1" placeholder="Ersatz erfassen"></v-text-field>
              </v-col>

              <!--              <v-col v-if="isDisplayed('backup1_reported')" cols="2" class="py-0">-->
              <!--           Don't display (Decision Michèle 13.09.24)     <v-checkbox clearable v-model="editedItem.backup1_reported" label="Ersatz 1 Ok"></v-checkbox>-->
              <!--              </v-col>-->
              <v-col v-if="isDisplayed('backup1_until')" cols="3" class="py-0">
                <time-field v-model="editedItem.backup1_until" :defaultDate="currentDate" placeholder="Ersatz 1 bis erfassen" label="Ersatz 1 bis"></time-field>
              </v-col>

              <v-col v-if="isDisplayed('backup2')" cols="5" class="py-0">
                <v-text-field clearable v-model="editedItem.backup2" placeholder="Ersatz 2 erfassen" label="Ersatz 2"></v-text-field>
              </v-col>
              <v-col v-if="isDisplayed('backup2_reported')" cols="6" class="py-0">
                <!--            Don't display (Decision Michèle 13.09.24), but leave column as placeholder    <v-checkbox v-model="editedItem.backup2_reported" label="Ersatz 2 Ok"></v-checkbox>-->
              </v-col>
              <v-col v-if="isDisplayed('absenceDuration')" cols="5" class="py-0">
                <v-select
                  v-model="editedItem.absenceDurationId"
                  :items="absenceDurations"
                  item-text="text"
                  item-value="id"
                  placeholder="Dauer der Abwesenheit"
                  label="Dauer der Abwesenheit"
                ></v-select>
              </v-col>
              <v-col v-if="isDisplayed('remark')" cols="7" class="py-0">
                <v-select
                  v-model="editedItem.remarkId"
                  :items="remarks"
                  item-text="text"
                  item-value="id"
                  clearable
                  placeholder="Bemerkung erfassen"
                  label="Bemerkung"
                ></v-select>
              </v-col>
              <v-col v-if="isDisplayed('reportingDate')" cols="5" class="py-0">
                <v-menu
                  v-model="reportedDateDialog"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  z-index="999"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="formattedReportedAtDate"
                      label="Meldedatum"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="reportedAtDate" first-day-of-week="1" @input="reportedDateDialog = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col v-if="isDisplayed('reportedAtTime')" cols="2" class="py-0">
                <time-field v-model="reportedAtTime" :defaultDate="currentDate" placeholder="Meldezeit" label="Meldezeit"></time-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col v-if="isDisplayed('zueri9State')" cols="12" class="py-2">
                <label class="text-subtitle-1">Status</label>
                <state-picker v-model="editedItem.zueri9State" :statesById="zueri9StatesById"></state-picker>
              </v-col>
              <v-col v-if="isDisplayed('dispoState')" cols="12" class="py-2">
                <label class="text-subtitle-1">Status</label>
                <state-picker v-model="editedItem.dispoState" :statesById="dispoStatesById"></state-picker>
              </v-col>
            </v-row>
          </v-form>
        </v-row>
      </v-card-text>

      <v-card-actions class="d-flex align-end dialog-header-footer">
        <div class="caption">* bezeichnet obligatorische Felder</div>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close"> Abbrechen</v-btn>
        <v-btn color="primary" :disabled="!editFormValid || isSaving" @keydown.enter="validateAndSave" @click="validateAndSave">Speichern</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import dateUtils from '@/common/dateUtils';
import { mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import absencesDialogFields from '@/modules/customerVbzWorksheet/viewComponents/absences/AbsencesDialogFields';
import StatePicker from '@/modules/customerVbzWorksheet/components/StatePicker.vue';
import PersonAutocomplete from '@/modules/customerVbzWorksheet/components/PersonAutocomplete.vue';
import DutyLookup from '@/modules/customerVbzWorksheet/components/DutyLookup.vue';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';
import TimeField from '@/modules/customerVbzWorksheet/components/TimeField.vue';
import worksheetService from '@/modules/customerVbzWorksheet/worksheetService';
import DutyPartsView from '@/modules/customerVbzWorksheet/components/DutyPartsView.vue';
import DutyPartsOwnDataView from '@/modules/customerVbzWorksheet/components/DutyPartsOwnDataView.vue';

export default {
  name: 'AbsenceDialog',
  mixins: [wsMixin],
  components: { DutyPartsOwnDataView, DutyPartsView, TimeField, DutyLookup, PersonAutocomplete, StatePicker },
  props: {
    isNew: {
      type: Boolean,
    },
    editItem: {
      type: Object,
    },
  },

  data() {
    return {
      isSaving: false,
      editedItem: this.editItem,
      editedItemVbzNr: '',
      isDutyLookupDialogOpen: false,
      isPersonLookupDialogOpenVbzNr: false,
      isPersonLookupDialogOpenZueri9VbzNr: false,
      isPersonLookupDialogOpenBackup1: false,

      mailToDialog: false,
      reportedDateDialog: false,
      dialogDelete: false,
      reportedAtDate: null,
      reportedAtTime: null,
      fzgType: null,
      editFormValid: true,
      vbzNrRules: [(v) => !!v || 'VBZ Nr. ist erforderlich'],
      dutyFromRules: [(v) => !!v || 'Beginn ist erforderlich'],
      dutyEndRules: [(v) => !!v || 'Ende ist erforderlich'],
      dutyRules: [(v) => !!v || 'Dienst ist erforderlich'],
      lineRules: [(v) => !!v || 'Linie/Kurs ist erforderlich'],
      reasonRules: [(v) => !!v || 'Grund ist erforderlich'],
      // illnessReasonRules: [(v) => v > -2 || 'Krankheitsgrund ist erforderlich'],
      // illnessReasonTextRules: [(v) => (this.editedItem.illnessReasonId === -1) && !v ? 'Krankheitsgrund ist erforderlich' : true],
    };
  },
  computed: {
    ...mapState('vbzWorksheet', {
      currentDate: (state) => state.contextDate,
      isOpen: (state) => state.absenceEditDialog,
    }),
    ...mapState('vbzWorksheet', [
      'reasons',
      'illnessReasons',
      'remarks',
      'absenceDurations',
      'zueri9Clients',
      'zueri9Reasons',
      'zueri9ReasonsById',
      'zueri9ClientsById',
      'zueri9StatesById',
      'dispoStatesById',
    ]),

    view() {
      return this.mx_isDispoView ? 'isForDispo' : 'isForZueri9';
    },
    dutySelection() {
      return this.editedItem && this.editedItem.dutySelection;
    },

    illnessReasonsExtended() {
      let illnessReasonsExtendedByOthersItem = [
        {
          id: -1,
          text: 'Diverses / Anderes',
        },
      ].concat(this.illnessReasons);
      return illnessReasonsExtendedByOthersItem;
    },
    needsIllnessReasonText() {
      return this.editedItem.illnessReasonId === -1;
    },
    dialog: {
      get() {
        return this.isOpen;
      },
      set(value) {
        this.$store.commit('vbzWorksheet/setAbsenceEditDialog', { value });
      },
    },
    formTitle() {
      return !this.editedItem.id ? 'Neue Meldung' : 'Meldung editieren';
    },

    formattedReportedAtDate: {
      get() {
        return this.reportedAtDate ? dateUtils.formatAsLocaleShortDate(new Date(Date.parse(this.reportedAtDate))) : '';
      },
      set(value) {
        console.debug('set reportedatDate to ', value);
        this.reportedAtDate = value;
      },
    },
  },
  methods: {
    ...mapMutations('vbzWorksheet', ['pushDomainItem']),
    onDutySelected(selection) {
      let { dutyId, resolvedDutyActivities, selectedDutyParts } = selection;
      console.debug('selectedDutyParts', selectedDutyParts);
      this.editedItem.dutySelection = selection;

      // describes the duty selection index (one or two duty parts can be selected)
      // However in case of creating a
      selection.dutySelectionPart = 0;

      if (selectedDutyParts.length > 0) {
        let d = selectedDutyParts[0];
        console.debug(`save selected duty d.dutyPartName=${d.dutyPartName}`, d);
        if (this.mx_isZueri9View) {
          // in case of editing by zueri9 store items within separate fields
          this.editedItem.z9Duty = d.dutyPartName;
          this.editedItem.z9DutyFrom = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.from);
          this.editedItem.z9DutyUntil = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.to);
          this.editedItem.z9DutyFromLoc = d.fromLocation;
          this.editedItem.z9DutyUntilLoc = d.toLocation;
          this.editedItem.z9Line = `${d.line || 'na.'}/${d.course || 'na.'}`;
        } else {
          this.editedItem.duty = d.dutyPartName;
          this.editedItem.dutyFrom = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.from);
          this.editedItem.dutyUntil = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.to);
          this.editedItem.dutyFromLoc = d.fromLocation;
          this.editedItem.dutyUntilLoc = d.toLocation;
          this.editedItem.line = `${d.line || 'na.'}/${d.course || 'na.'}`;
        }
      }

      if (selectedDutyParts.length > 1) {
        let d = selectedDutyParts[1];
        this.editedItem.duty2 = d.dutyPartName;
        this.editedItem.dutyFrom2 = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.from);
        this.editedItem.dutyUntil2 = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, d.to);
        this.editedItem.dutyFromLoc2 = d.fromLocation;
        this.editedItem.dutyUntilLoc2 = d.toLocation;
        this.editedItem.line2 = `${d.line}/${d.course}`;
      }
      this.isDutyLookupDialogOpen = false;
    },
    isDisplayed(fieldName) {
      let fieldDef = absencesDialogFields[fieldName];
      if (!fieldDef) {
        return true;
      }
      return fieldDef[this.view];
    },
    setFzgType(value) {
      Vue.set(this.editedItem, 'fzgType', value);
      this.fzgType = value;
      console.debug('setFzgType', value);
    },
    validate() {
      return this.$refs.form.validate();
    },
    validateAndSave() {
      if (this.validate()) {
        console.debug('validateAndSave', this.reportedAtDate);
        this.editedItem.reportedAtDate = this.reportedAtDate;
        let reportedAtDate = dateUtils.parseISOString(this.reportedAtDate);
        let reportedAtTime = dateUtils.parseISOString(this.reportedAtTime);
        reportedAtTime.setFullYear(reportedAtDate.getFullYear());
        reportedAtTime.setMonth(reportedAtDate.getMonth());
        reportedAtTime.setDate(reportedAtDate.getDate());
        this.editedItem.reportedAtTime = reportedAtTime.toISOString();
        console.debug(' this.editedItem.reportedAtTime', this.editedItem.reportedAtTime);
        this.editedItem.assignedTo = this.mx_isDispoView ? 'dispo' : 'zueri9';
        this.editedItem._updated = true;
        this.isSaving = true;
        this.$emit('onSave', this.editItem);
      }
    },
    reset() {
      if (this.$refs.form) this.$refs.form.reset();
    },
    resetValidation() {
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    close() {
      this.dialog = false;
      this.editFormValid = true;
      this.reset();
      this.$emit('onClose');
    },
  },
  watch: {
    editedItem: {
      handler(newValue, oldValue) {
        let time = Date.parse(newValue.reportedAtTime);
        if (isNaN(time)) {
          time = Date.now();
        }
        this.reportedAtDate = new Date(time).toISOString().substring(0, 10);
        this.reportedAtTime = new Date(time).toISOString();
        this.fzgType = newValue.fzgType;
      },
      deep: true,
    },
    editItem(newValue, oldValue) {
      this.editedItemVbzNr = null;
      this.editedItem = newValue;
    },
    isOpen(newValue, oldValue) {
      if (newValue === true) {
        console.debug('Dialog set to be opened, scroll firstRow into view');
        let firstRowEl = this.$refs['firstRow'];
        if (firstRowEl) {
          this.$nextTick(() => {
            this.mx_scrollElementIntoView(firstRowEl);
          });
        }
        this.isSaving = false;
        this.resetValidation();
      }
    },
    'editedItem.reasonId': {
      handler(newReasonId) {
        // OP-11554: Auto-populate fields if reason is "Ferien"
        const selectedReason = this.reasons.find((r) => r.id === newReasonId);

        if (selectedReason && selectedReason.text === 'Ferien') {
          this.editedItem.duty = 'Ferien';

          const zeroTime = worksheetService.getDateIsoStringFromDateAndHHMM(this.currentDate, '00:00');
          this.editedItem.dutyFrom = zeroTime;
          this.editedItem.dutyUntil = zeroTime;

          this.editedItem.dutyFromLoc = '0';
          this.editedItem.dutyUntilLoc = '0';
          this.editedItem.line = '0';
        }
      },
    },
  },
};
</script>
